<div class="caption-sm group-label">{{ label() }}</div>
<div class="group-options">
  <ng-content />
</div>
